import { VisualisationContextProps } from 'widgets/supportVisualisation/Content/VisualisationContentProps';
import React from 'react';
import { WidgetPanelGrid } from 'widgets/supportVisualisation/Content/Widgets/WidgetPanelGrid';
import { SubscriberInfo } from 'embedded/api/out/Subscription';
import { v4 as uuid } from 'uuid';
import './SupportVisualisationEmbeddedApiSubscribers.scss';

export function SupportVisualisationEmbeddedApiSubscribers(
    props: VisualisationContextProps
) {
    const { state, height, width } = props;

    const style = { height, width };

    const embeddedApiSubscribers = state?.embeddedApiSubscribers;

    if (!embeddedApiSubscribers) {
        return (
            <div
                className={'SupportVisualisationEmbeddedApiSubscribers'}
                style={style}
            >
                None found in state
            </div>
        );
    }

    const gridData = getGridData(embeddedApiSubscribers);

    return (
        <div
            className={'SupportVisualisationEmbeddedApiSubscribers'}
            style={style}
        >
            <WidgetPanelGrid
                data={gridData}
                style={style}
                csvFileName={'embeddedApiMessages'}
                getRowDataId={(i) => i.id}
            />
        </div>
    );
}

function getGridData(
    data: SubscriberInfo[]
): Array<SubscriberInfo & { id: string }> {
    return data.map((d) => ({ ...d, id: uuid() }));
}
